import { ISelectedFilterBody } from 'components/filter/models/TableFilterModels';

import { InputNames } from '../models/InputsModel';
import { operationMap } from './InputsValidations';

interface ISetInputsWithLocalstorage {
	column: string;
	localStorageValue: ISelectedFilterBody[];
	name: InputNames;
	setInputValue: any;
	setSelectedOptions?: any;
}

export function setInputsWithLocalstorage({
	column,
	localStorageValue,
	name,
	setInputValue,
	setSelectedOptions,
}: ISetInputsWithLocalstorage) {
	if (localStorageValue) {
		const operation = operationMap[name];

		const value = localStorageValue.find(item => {
			return item.column_name === column && item.operation === operation;
		});

		if (value) {
			if (setSelectedOptions) {
				setSelectedOptions(value.values);
			} else {
				setInputValue(prev => ({
					...prev,
					[name]: value.values,
				}));
			}
		}
	}
}
